import React, { Component } from 'react';
import { Link } from 'react-router';

export default class NDAd extends Component {
  isAnotherClient() {
    const { user, project } = this.props
    return user['is_client'] && !user['is_creative'] && user.id !== project.client
  }

  isAnonymous() {
    return !this.props.user.id;
  }

  renderAction() {
    const { project, requestAccess, location, canRequestAccess } = this.props;

    /* pending request */
    if (project['nda_request_status'] == 'pending') {
      return <h3>Your request is pending</h3>
    }

    /* denied request */
    if (project['nda_request_status'] == 'denied') {
      return <h3>Your request was denied</h3>
    }

    /* anonymous user */
    if (this.isAnonymous()) {
      return (
        <Link rel="nofollow" to={"/login?next=" + location.pathname} className="btn btn-primary">
          Log in
        </Link>)
    }

    /* another client that not the project owner */
    if (this.isAnotherClient()) {
      return (
        <Link rel="nofollow" to={"/login?next=" + location.pathname} className="btn btn-primary">
          Log in as creative
        </Link>)
    }

    return (
      <div>
        { !canRequestAccess?
        <div className="participation-forbidden-reason">
          <strong>You cannot request access because you cannot submit entries</strong>
        </div> :
        <button onClick={requestAccess} className="btn btn-primary">
          Request access
        </button> }
      </div>
    )
  }

  render() {
    const { project, contract } = this.props
    const anonymous = this.isAnonymous()
    const anotherClient = this.isAnotherClient()

    if (!anonymous && !anotherClient && !contract) {
      return null
    }

    return (
      <div className="tour ndad-project">
        <div className="slide intro">
          <h2>Private Project</h2>
          <h3>You must be approved to view or participate in this project.</h3>
          <div className="row">
            <div className="ndad-intro-section columns small-16 medium-4 medium-offset-2">
              <i className="fa fa-lock" />
              <h3>NDA Required</h3>
              You agree not to talk about this project with anyone else.
            </div>

            {project.private_gallery?
            <div className="ndad-intro-section columns small-16 medium-4 ">
              <i className="fa fa-eye-slash" />
              <h3>Closed Gallery</h3>
              You will be able to see only your entries.
            </div>:
            <div className="ndad-intro-section columns small-16 medium-4 ">
              <i className="fa fa-eye" />
              <h3>Open Gallery</h3>
              You will be able to see all entries.
            </div>}

            {project.nda_portfolio_use_allowed?
            <div className="ndad-intro-section columns small-16 medium-4 ">
              <i className="fa fa-briefcase" />
              <h3>Portfolio Use</h3>
              You may use your entries in your portfolio.
            </div>:
            <div className="ndad-intro-section columns small-16 medium-4 ">
              <i className="fa fa-briefcase" />
              <h3>No Portfolio Use</h3>
              You won't be able to use your entries in your portfolio.
            </div>}
          </div>
          { this.renderAction() }
        </div>
    </div>);
  }
}




// WEBPACK FOOTER //
// ./project/components/brief/ndad.jsx